
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ProductContainer extends Vue {}
